import { MutableRefObject, useEffect, useLayoutEffect, useRef, useState } from 'react'
import NotificationsFeed from './notifications-feed/notifications-feed.component'
import './notifications.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean
  setOpen: (openUserMenu: boolean) => void
  button: MutableRefObject<any> | null
}

export default ({ className = '', style, open = false, setOpen, button = null }: Props) => {
  const notificationWrapperRef = useRef<any>(null)
  const [height, setHeight] = useState(window?.innerHeight)
  const [width, setWidth] = useState(window?.innerWidth)

  useLayoutEffect(() => {
    const updateHeight = () => {
      setHeight(window?.innerHeight)
    }
    const updateWidth = () => {
      setWidth(window?.innerWidth)
    }
    window.addEventListener('resize', updateHeight)
    window.addEventListener('resize', updateWidth)
    return () => {
      window.removeEventListener('resize', updateHeight)
      window.removeEventListener('resize', updateWidth)
    }
  }, [])

  useEffect(() => {
    function handleClickOutsideNotifications(event: any) {
      if (
        button?.current &&
        !button?.current?.contains(event.target) &&
        !notificationWrapperRef?.current?.contains?.(event.target) &&
        setOpen &&
        typeof setOpen === 'function'
      ) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutsideNotifications)
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideNotifications)
    }
  }, [setOpen, button, notificationWrapperRef])

  return (
    <div
      className={`notifications-wrapper ${className} scrollbar ${open ? 'open' : ''}`}
      id="notifications-wrapper"
      ref={notificationWrapperRef}
    >
      {open ? <NotificationsFeed elementToScroll="notifications-wrapper" notificationClicked={() => setOpen(false)} /> : null}
    </div>
  )
}
